class LoginRequiredModal extends HTMLElement {
  constructor() {
    super();

    if (this.querySelector('.modal__close')) {
      const buttons = this.querySelectorAll('.modal__close');
      for(let i=0; i<buttons.length; i++) {
        buttons[i].addEventListener('click', function(e) {
          e.target.closest('.modal').removeAttribute('open');
        });
      }
    }
  }

  open() {
    this.querySelector('.modal').setAttribute('open', true);
  }

  close() {
    this.querySelector('.modal').removeAttribute('open');
  }

  isOpen() {
    return this.querySelector('.modal').hasAttribute('open');
  }
}

customElements.define('login-required-modal', LoginRequiredModal);
